module.exports = {
  AVAILABILITY_FAILURE: 'failure',
  AVAILABILITY_TRANSFER_SIZE: 'transfersize',
  AVAILABILITY_BROWSER_ERRORS: 'errors-js',
  BROWSER: 'browser',
  WINDOW_DOM: 'window-dom',
  D2ID: 'd2id',
  NETWORK_TYPE: 'network-type',
  NETWORK_SPEED: 'network-speed',
  USER_AGENT: 'user-agent',
  RAM_SIZE: 'ram-size',
  CPU_CORES: 'cpu-cores',
  WINDOW_WIDTH: 'window-width',
  WINDOW_HEIGHT: 'window-height',
  LCP: 'lcp',
  CLS: 'cls',
  FCP: 'fcp',
  FID: 'fid',
  TBT: 'tbt',
  INP: 'inp',
  TTFB: 'time-to-first-byte',
  DNS_LOOKUP_TIME: 'dns-lookup-time',
  DOWNLOAD_TIME: 'download-time',
  FETCH_TIME: 'fetch-time',
  HEADER_SIZE: 'header-size',
  TOTAL_TIME: 'total-time',
  WORKER_TIME: 'worker-time',
  HYDRATE_COMPLETE: 'hydrate-complete',
  HYDRATE_DURATION: 'hydrate-duration',
  REDIRECT_COUNT: 'redirect-count',
  DOM_COMPLETE: 'dom-complete',
  DOM_INTERACTIVE: 'dom-interactive',
  DOM_CONTENT_LOADED_END: 'dom-content-loaded-end',
  DOM_CONTENT_LOADED_START: 'dom-content-loaded-start',
  DOM_CONTENT_LOADED: 'dom-content-loaded',
  ONLOAD: 'onload',
  ONLOAD_END: 'onload-end',
  ONLOAD_START: 'onload-start',
  REQUEST_START: 'request-start',
  RESPONSE_START: 'response-start',
  RESPONSE_END: 'response-end',
  RESPONSE_TIME: 'response-time',
  NAVIGATION_TYPE: 'navigation-type',
  NAVIGATION_TIMING: 'navigationtiming',
  INITIAL_CONTENT_SIZE: 'initial-content-size',
  DARK_MODE: 'dark-mode',
  REDUCED_MOTION: 'reduced-motion',
  REDUCED_COLOR: 'reduced-contrast',
  URL: 'url',
  X_CDN: 'cdn',
  DURATION_SUM: 'duration-sum',
  RESOURCE_SIZE: 'resources-size',
  RESOURCE_FAILURE: 'resources-failure',
  RESOURCE_SUCCESS: 'resources-success',
  DEBUG_TARGET_LCP: 'debug-target-lcp',
  DEBUG_TARGET_FID: 'debug-target-fid',
  DEBUG_TARGET_CLS: 'debug-target-cls',
  DEBUG_TARGET_INP: 'debug-target-inp',
  RESOURCE_TIMING: 'resourceTiming',
  SESSION_REPLAY: 'session-replay',
  SESSION_REPLAY_CTX: 'session-replay-ctx',
  SESSION_REPLAY_START: 'start-recording',
  SESSION_REPLAY_STOP: 'stop-recording',
  TRACEABILITY_ID: 'traceability-id',
  APP_NAME: 'application',
  SCOPE_NAME: 'scope',
  DEVICE: 'device',
  PLATFORM_ID: 'platform',
  SITE_ID: 'site',
  WEBVIEW: 'webview',
  SESSION_ID: 'session-id',
  MLDATA_SESSION_ID: '_mldataSessionId',
  REQUEST_ID: 'requestId',
  VIEW_NAME: 'view-name',
  CUSTOM_ATTRIBUTES: 'custom-attributes',
  USER_ID: 'user-id',
  CONTEXT_ID: 'context-id',
  FRONTEND_SESSION_ID: 'frontend-session-id',
};
